const Yunqiao = () => import("../views/yunqiao/yunqiao.vue")
const Detail_sddsf = () => import("../views/yunqiao/detail_sddsf.vue")
const Detail_syyq = () => import("../views/yunqiao/detail_syyq.vue")
const Shoushi_project1 = () => import("../views/yunqiao/shoushi_project1.vue")
const Shoushi_project2 = () => import("../views/yunqiao/shoushi_project2.vue")
const Shoushi_project3 = () => import("../views/yunqiao/shoushi_project3.vue")
const Lezhi_project1 = () => import("../views/yunqiao/lezhi_project1.vue")
const Lezhi_project2 = () => import("../views/yunqiao/lezhi_project2.vue")
const Lezhi_project3 = () => import("../views/yunqiao/lezhi_project3.vue")
const Lezhi_project4 = () => import("../views/yunqiao/lezhi_project4.vue")
const Lezhi_project5 = () => import("../views/yunqiao/lezhi_project5.vue")

const Wisdom = () => import("../views/yunqiao/wisdom/wisdom_home.vue")
const WisdomSubject = () => import("../views/yunqiao/wisdom/wisdom_subject.vue")
const WisdomSpecial = () => import("../views/yunqiao/wisdom/wisdom_special.vue")
const WisdomExpert = () => import("../views/yunqiao/wisdom/wisdom_expert.vue")
const WisdomProject = () => import("../views/yunqiao/wisdom/wisdom_project.vue")

const WisdomSubjectDetail = () => import("../views/yunqiao/wisdom/wisdom_subject_detail.vue")
const WisdomProjectDetail = () => import("../views/yunqiao/wisdom/wisdom_project_detail.vue")
const WisdomLive = () => import("../views/yunqiao/wisdom/live.vue")

const Logistics = () => import("../views/yunqiao/logistics/logistics_home.vue")
const LogisticsCertificate = () => import("../views/yunqiao/logistics/logistics_certificate.vue")

const InnerMogolia = () => import("../views/yunqiao/innerMogolia/innerMongolia_home.vue")
const InnerMogoliaDirectory = () => import("../views/yunqiao/innerMogolia/innerMongolia_directory.vue")






export default[
    {
        path:"/yunqiao",
        name:'yunqiao',
        component:Yunqiao,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/detail_sddsf",
        name:'detail_sddsf',
        component:Detail_sddsf,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/detail_syyq",
        name:'detail_syyq',
        component:Detail_syyq,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/shoushi_project1",
        name:'shoushi_project1',
        component:Shoushi_project1,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/shoushi_project2",
        name:'shoushi_project2',
        component:Shoushi_project2,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/shoushi_project3",
        name:'shoushi_project3',
        component:Shoushi_project3,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/lezhi_project1",
        name:'lezhi_project1',
        component:Lezhi_project1,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/lezhi_project2",
        name:'lezhi_project2',
        component:Lezhi_project2,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/lezhi_project3",
        name:'lezhi_project3',
        component:Lezhi_project3,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/lezhi_project4",
        name:'lezhi_project4',
        component:Lezhi_project4,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/lezhi_project5",
        name:'lezhi_project5',
        component:Lezhi_project5,
        meta:{
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/wisdom",
        name:'wisdom',
        component:Wisdom,
        redirect: {
            name: "wisdomSubject"
        },
        meta:{
            title:'首师智研',
            keepAlive: true
        },
        children:[
            {
                path:"subject",
                name:'wisdomSubject',
                component:WisdomSubject,
                meta:{
                    wsActive:1,
                    title:'学科培训',
                    keepAlive: true,
                    columnId:0,
                },
            },
            {
                path:"special",
                name:'wisdomSpecial',
                component:WisdomSpecial,
                meta:{
                    wsActive:2,
                    title:'专项培训',
                    keepAlive: true,
                    columnId:0,
                },
            },
            {
                path:"expert",
                name:'wisdomExpert',
                component:WisdomExpert,
                meta:{
                    wsActive:3,
                    title:'专家团队',
                    keepAlive: true,
                    columnId:0,
                },
            },
            {
                path:"project",
                name:'wisdomProject',
                component:WisdomProject,
                meta:{
                    wsActive:4,
                    title:'项目案例',
                    keepAlive: true,
                    columnId:0,
                },
            },
        ]
    },
    {
        path:"/yunqiao/subject/detail/:id",
        name:'wisdomSubjectDetail',
        component:WisdomSubjectDetail,
        meta:{
            title:'学科培训详情',
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/special/detail/:id",
        name:'wisdomSpecialDetail',
        component:WisdomSubjectDetail,
        meta:{
            title:'专项培训详情',
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/project/detail/:id",
        name:'wisdomProjectDetail',
        component:WisdomProjectDetail,
        meta:{
            title:'项目案例详情',
            keepAlive: true
        }
    },
    {
        path:"/yunqiao/live/:id",
        name:'wisdomLive',
        component:WisdomLive,
        meta:{
            title:'课程预览',
            keepAlive: true
        }
    },
    // 1+x后勤管理系统
    {
        path:"/yunqiao/logistics",
        name:'logistics',
        component:Logistics,
        redirect: {
            name: "logisticsSubject"
        },
        meta:{
            title:'1+x后勤管理与职业教育系统',
            keepAlive: true
        },
        children:[
            {
                path:"subject",
                name:'logisticsSubject',
                component:WisdomSubject,
                meta:{
                    wsActive:1,
                    title:'精品课程',
                    keepAlive: true
                },
            },
            {
                path:"expert",
                name:'logisticsExpert',
                component:WisdomExpert,
                meta:{
                    wsActive:2,
                    title:'专家团队',
                    keepAlive: true
                },
            },
            {
                path:"project",
                name:'logisticsProject',
                component:WisdomProject,
                meta:{
                    wsActive:3,
                    title:'项目案例',
                    keepAlive: true
                },
            },
            {
                path:"certificate",
                name:'logisticsCertificate',
                component:LogisticsCertificate,
                meta:{
                    wsActive:4,
                    title:'证书查询',
                    keepAlive: true
                },
            },
        ]
    },
     // 内蒙古项目
     {
        path:"/yunqiao/innerMongolia",
        name:'innerMongolia',
        component:InnerMogolia,
        redirect: {
            name: "innerMogoliaNews"
        },
        meta:{
            title:'内蒙古自治区教师专项培训',
            keepAlive: true
        },
        children:[
            {
                path:"news",
                name:'innerMogoliaNews',
                component:WisdomProject,
                meta:{
                    wsActive:1,
                    title:'新闻资讯',
                    keepAlive: true
                },
            },
            {
                path:"subject",
                name:'innerMogoliaCourse',
                component:WisdomSubject,
                meta:{
                    wsActive:2,
                    title:'精品课程',
                    keepAlive: true
                },
            },
            {
                path:"expert",
                name:'innerMogoliaExpert',
                component:WisdomExpert,
                meta:{
                    wsActive:3,
                    title:'专家团队',
                    keepAlive: true
                },
            },
            {
                path:"directory",
                name:'innerMogoliaDirectory',
                component:InnerMogoliaDirectory,
                meta:{
                    wsActive:4,
                    title:'项目校名录',
                    keepAlive: true
                },
            },
        ]
    },
]